import React from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
//import Dashboard from "@material-ui/icons/Dashboard";
//import Search from "@material-ui/icons/Search";
// core components
//import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";


import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";


import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import './dropdown_style.css';


//import { types } from '../../types/types';
import { dataActions } from '../../store/data-slice';
import { startLogout } from '../../store/auth-actions'

const useStyles = makeStyles(styles);


export default function AdminNavbarLinks() {
  
  const { name } = useSelector( state => state.auth);
  const { plantaciones, allPlantaciones, indexPlantacion,language } = useSelector( state => state.data);
  const history = useHistory();
  
  const translations = {
    en: {
      label1: "Crop",
      labelProfile: "Profile Data",
      labelSession: "Close session",
      lLot: "Lot/Crop",
      lAll: "All",
    },
    es: {
      label1: "Plantación",
      labelProfile: "Datos de Perfil",
      labelSession: "Cerrar Sessión",
      lLot: "Lote/Plantación",
      lAll: "Todas",
    }
  };

  // Get the current translation based on language
  const t = translations[language];
  //console.log('Language:', language);
  //console.log(plantaciones[0].sensores[0].name +','+ allPlantaciones + ','+ indexPlantacion);
  
  const dispatch = useDispatch();

  const classes = useStyles();
  const [openNotification, setOpenNotification] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  const handleClickNotification = (event) => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };
  const handleCloseNotification = () => {
    setOpenNotification(null);
  };
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  const handleLogout = () => {
    //console.log("Logout");
    dispatch( startLogout());
    setOpenProfile(null);
    history.replace('/login');

  };


  let options = [{ value: -1, label: t.lAll }];
  let index_plantacion = 0;
  plantaciones.forEach( (plantacion) => {
    options.push({ value: index_plantacion, label: plantacion.nombre });
    index_plantacion++;
  });

  //const defaultOption = options[0];
  //run default allPlantaciones selected


  function _onSelect (option) {
    console.log('You selected ', option.label, ' Index ', option.value)
    if (option.value !== -1){
      dispatch(
        dataActions.dataSelectPlantacion({
            allPlantaciones: false,
            indexPlantacion: option.value,
      }))
    }else{
      dispatch(
        dataActions.dataSelectPlantacion({
            allPlantaciones: true,
            indexPlantacion: -1,
      }))

    }
    //this.setState({selected: option})
  }

  return (
    <div>
      {/* <div className={classes.searchWrapper}>
        <CustomInput
          formControlProps={{
            className: classes.margin + " " + classes.search,
          }}
          inputProps={{
            placeholder: "Search",
            inputProps: {
              "aria-label": "Search",
            },
          }}
        />
        <Button color="white" aria-label="edit" justIcon round>
          <Search />
        </Button>
      </div> */}
      {/* <Button
        color={window.innerWidth > 959 ? "transparent" : "white"}
        justIcon={window.innerWidth > 959}
        simple={!(window.innerWidth > 959)}
        aria-label="Dashboard"
        className={classes.buttonLink}
      >
        <Dashboard className={classes.icons} />
        <Hidden mdUp implementation="css">
          <p className={classes.linkText}>Dashboard</p>
        </Hidden>
      </Button> */}
      
      <div className={classes.manager}>

      {/* <div className={classes.user} >
        <h4> Cultivo: </h4>
      </div> */}
      

      <h4 style={{display: "inline", color: "white", fontSize:'15px', marginLeft:'10px', padding:'10px'}}> 
                 {t.label1}: &nbsp;
      </h4>
      
        <div className={classes.dropdown} >
        
          <Dropdown className='Dropdown-root' menuClassName='.Dropdown-menu' controlClassName='.Dropdown-control' options={options} onChange={_onSelect} placeholder={t.lLot} />
        </div>


        <div className={classes.user} >
            {name}
        </div>


      {/* //Menu de notificaciones */}
      
       {/*  <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openNotification ? "notification-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickNotification}
          className={classes.buttonLink}
        >
          <Notifications className={classes.icons} />
          <span className={classes.notifications}>5</span>
          <Hidden mdUp implementation="css">
            <p onClick={handleCloseNotification} className={classes.linkText}>
              Notification
            </p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openNotification }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="notification-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={classes.dropdownItem}
                    >
                      Mike John responded to your email
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={classes.dropdownItem}
                    >
                      You have 5 new tasks
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={classes.dropdownItem}
                    >
                      You{"'"}re now friend with Andrew
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={classes.dropdownItem}
                    >
                      Another Notification
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={classes.dropdownItem}
                    >
                      Another One
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers> */}
      
      
      </div>


      <div className={classes.manager}>
      
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? "profile-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
          
        >
          

          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>Profile</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openProfile }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={handleCloseProfile}
                      className={classes.dropdownItem}
                    >
                      {t.labelProfile}
                    </MenuItem>
                    
                    
                    {/* //menu de settings */}
                    {/* <MenuItem
                      onClick={handleCloseProfile}
                      className={classes.dropdownItem}
                    >
                      Settings
                    </MenuItem>
 */}
                    <Divider light />
                    <MenuItem
                      onClick={handleLogout}
                      className={classes.dropdownItem}
                    >
                      {t.labelSession}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}
